import { EnumUtils } from 'src/app/utils/enum-utils';
import { PrimaryCannabinoid } from './cannabinoid';
import { SectionColumnConfigCollectiveCannabinoidKey } from './section-column-config-collective-cannabinoid-key';

/**
 * Order matters here, since many places use Object.values(SectionColumnCannabinoidType) to get cannabinoids.
 *
 * Class names are affected by these names. If an enum value changes, make sure to search all css files
 * for the old value.
 */
export const SectionColumnCannabinoidType = EnumUtils.createEnum([
  ...EnumUtils.getCannabinoids().filter(it => it !== PrimaryCannabinoid.TAC),
  PrimaryCannabinoid.TAC,
  ...Object.values(SectionColumnConfigCollectiveCannabinoidKey)
]);
